export const getStoreFinderUrl = (storeName: string | undefined) => {
  const url = storeName
    .toLowerCase()
    .replace(/[\s-\W,]+/g, '-')
    .replace(/\s+/g, '-')
    .replace(/^-+|-+$/g, '');

  return `/pages/${url}`;
};
